// 用户组
export const UserGroup = {
  free: 1,
  professional: 2,
  enterprise: 3,
  qihoo: 4
}
